<template>
  <div class="sidebar-topics-wrap">
    <div
      v-if="!conversationUiFlags.isFetching"
      class="contact-conversation--list"
    >
      <div
        v-on-clickaway="closeDropdownTopicLabel"
        class="topic-wrap"
        @keyup.esc="closeDropdownTopicLabel"
      >
        <add-topic-label @add="toggleTopicLabels" />
        <woot-label
          v-for="topicLabel in activeTopicLabels"
          :key="topicLabel.id"
          :title="topicLabel.title"
          :description="topicLabel.description"
          :show-close="true"
          :color="topicLabel.color"
          variant="smooth"
          @click="removeTopicLabelFromConversation"
        />

        <div class="dropdown-wrap">
          <div
            :class="{ 'dropdown-pane--open': showSearchDropdownTopicLabel }"
            class="dropdown-pane"
          >
            <topic-label-dropdown
              v-if="showSearchDropdownTopicLabel"
              :account-topic-labels="accountTopicLabels"
              :selected-topic-labels="savedTopicLabels"
              @add="addTopicLabelToConversation"
              @remove="removeTopicLabelFromConversation"
            />
          </div>
        </div>
      </div>
    </div>
    <spinner v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Spinner from 'shared/components/Spinner';
import TopicLabelDropdown from 'shared/components/ui/topicLabel/TopicLabelDropdown';
import AddTopicLabel from 'shared/components/ui/dropdown/AddTopicLabel';
import { mixin as clickaway } from 'vue-clickaway';
import conversationTopicLabelMixin from 'dashboard/mixins/conversation/topicLabelMixin';

export default {
  components: {
    Spinner,
    TopicLabelDropdown,
    AddTopicLabel,
  },

  mixins: [clickaway, conversationTopicLabelMixin],
  props: {
    conversationId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      selectedTopicLabels: [],
      showSearchDropdownTopicLabel: false,
    };
  },

  computed: {
    ...mapGetters({
      conversationUiFlags: 'conversationTopicLabels/getUIFlags',
      topicUiFlags: 'conversationTopicLabels/getUIFlags',
    }),
  },
  methods: {
    toggleTopicLabels() {
      this.showSearchDropdownTopicLabel =
        !this.showSearchDropdownTopicLabel;
    },
    closeDropdownTopicLabel() {
      this.showSearchDropdownTopicLabel = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-topics-wrap {
  margin-bottom: 0;
}
.contact-conversation--list {
  width: 100%;

  .topic-wrap {
    line-height: var(--space-medium);
    position: relative;

    .dropdown-wrap {
      display: flex;
      left: -1px;
      margin-right: var(--space-medium);
      position: absolute;
      top: var(--space-medium);
      width: 100%;

      .dropdown-pane {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

.error {
  color: var(--r-500);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
}
</style>

